import React from 'react'
import { ActiveVisasTable } from '../../components/table/ActiveVisasTable/Active-Visas-Table'

export const ActiveVisas = () => {
    return (
        <div className='h-auto '>
            <ActiveVisasTable />
        </div>
    )
}
